/**
 * Web SHA-1 adapter for `@auctisync/shared`'s breached-password check.
 *
 * The shared module takes hashing as a parameter rather than importing it,
 * because `crypto.subtle` exists in browsers but NOT in React Native (native
 * supplies `expo-crypto` instead). This is the web half of that port.
 *
 * SHA-1 is the index key HaveIBeenPwned publishes its corpus under — it is not
 * protecting anything here. Password storage remains bcrypt inside Supabase
 * Auth. See the module doc in `packages/shared/src/security/index.ts`.
 *
 * `crypto.subtle` requires a secure context: HTTPS in production, and
 * `localhost` counts as secure for development. If it is ever unavailable the
 * promise rejects and the shared check FAILS OPEN — the user is not blocked.
 */
export async function sha1Hex(input: string): Promise<string> {
  const bytes = new TextEncoder().encode(input);
  const digest = await crypto.subtle.digest('SHA-1', bytes);
  return Array.from(new Uint8Array(digest))
    .map((byte) => byte.toString(16).padStart(2, '0'))
    .join('')
    .toUpperCase();
}
